/**
 * GeoServer WFS solar_module 피처 속성 → UI 표시용 필드 정규화
 *
 * solar_module 테이블에는 array_id/string_id가 없고 temp_array_id/temp_string_id 또는
 * GeoServer SQL 뷰 조인 결과 array_id/string_id 가 올 수 있다.
 */
export function resolveSolarModuleWfsProperties(props = {}) {
  if (!props || typeof props !== 'object') {
    return {
      solarModuleSeq: null,
      moduleId: null,
      arrayId: null,
      stringId: null
    };
  }

  const solarModuleSeq =
    props.solar_module_seq ?? props.solarModuleSeq ?? props.seq ?? null;

  const moduleId = props.module_id ?? props.moduleId ?? null;

  const arrayId =
    props.array_id ??
    props.temp_array_id ??
    props.solar_array_id ??
    props.arrayId ??
    null;

  const stringId =
    props.string_id ??
    props.temp_string_id ??
    props.solar_string_id ??
    props.stringId ??
    null;

  return { solarModuleSeq, moduleId, arrayId, stringId };
}
